import { initDataLayer, isBrowser } from '../util';
export function pushFilterNoResults() {
    initDataLayer();
    if (!isBrowser)
        return;
    window.dataLayer.push({
        event: 'filterNoResults',
        noSearchResults: true,
    });
}
